module.exports = __webpack_public_path__ + "img/hosting.cd121f99.svg";